import type { Week, TableHeader } from "./types";

export const REGULAR_DELIVERY_LIST_FILE_NAME = "RegularDeliveryList";

// 配列インデックス（0:日〜6:土）と曜日表示を一致させるための表示定義。
export const WEEKS: Array<Week> = ["日", "月", "火", "水", "木", "金", "土"];

/**
 * 定期配送一覧テーブルの列定義。
 * `key` は API レスポンスを画面表示用に整形した行データのプロパティ名と対応させる。
 */
export const TABLE_HEADERS: TableHeader[] = [
  {
    title: "会員番号",
    align: "start",
    sortable: false,
    key: "memberId",
  },
  {
    title: "名前(漢字)",
    align: "start",
    sortable: false,
    key: "memberName",
  },
  {
    title: "配送先住所",
    align: "start",
    sortable: false,
    key: "deliveryAddress",
  },
  {
    title: "配送先電話番号",
    align: "start",
    sortable: false,
    key: "deliveryPhone",
  },
  {
    title: "配送曜日",
    align: "center",
    sortable: false,
    key: "week",
  },
  {
    title: "便",
    align: "start",
    sortable: false,
    key: "deliveryIdName",
  },
  {
    title: "配達時間",
    align: "start",
    sortable: false,
    key: "deliveryTime",
  },
  {
    title: "",
    align: "center",
    sortable: false,
    key: "actions",
  },
];
